import { ErrorCode, ErrorMessage } from '@biteinc/common';
import { Strings } from '@biteinc/localization';

import { BackboneEvents } from '~/app/js/backbone-events';
import { localizeStr } from '~/app/js/localization/localization';

import Analytics from '../utils/analytics';
import { GCNLoyaltyProgramHeaderView } from './gcn_loyalty_program_header_view';
import { GCNMarketingConsentView } from './gcn_marketing_consent_view';
import { GCNPhoneNumberEntryView } from './gcn_phone_number_entry_view';

export const GCNSimpleLoyaltySmsSignupView = GCNPhoneNumberEntryView.extend({
  className() {
    return `${GCNPhoneNumberEntryView.prototype.className.apply(this)} simple-signup`;
  },

  render(...args) {
    GCNPhoneNumberEntryView.prototype.render.apply(this, args);

    const orderId = gcn.orderManager.getOrderId();

    this.$header = new GCNLoyaltyProgramHeaderView({
      isLoyaltySignUp: true,
    }).render().$el;

    this.$el.prepend(this.$header);

    this.__$label.htmlOrText(`${localizeStr(Strings.ENTER_PHONE_LOYALTY)}:`);

    if (gcn.menu.settings.get('marketingConsentCheckbox')) {
      this.marketingConsentView = new GCNMarketingConsentView();
      this.marketingConsentView.render().$el.insertBefore(this.$('.footer'));
    }

    this.setDoneButtonText(localizeStr(Strings.SEND_LOYALTY_SMS));
    if (gcn.screenReaderIsActive) {
      this.__$cancelButton.onButtonTapOrHold('slsvCancel', () => {
        gcn.showNativeToast('Loyalty signup cancelled');
        gcn.menuView.dismissStablePopup();
      });
    }
    this.__$doneButton.onButtonTapOrHold('slsvDone', () => {
      gcn.menuView.showSpinner('Sending SMS');

      if (gcn.menu.settings.get('marketingConsentCheckbox')) {
        const guestConsentedToMarketing = this.marketingConsentView.getValue();
        gcn.orderManager.setGuestConsentedToMarketing(guestConsentedToMarketing);
      }

      gcn.maitred.sendSimpleSignUpMessage(this.__userNumber, orderId, (err) => {
        gcn.menuView.dismissSpinner();
        if (err) {
          if (gcn.screenReaderIsActive) {
            gcn.showNativeToast('Error sending SMS. Loyalty signup cancelled');
          }
          gcn.menuView.dismissStablePopup();
          if (err.code === ErrorCode.LocationMisconfigured) {
            gcn.menuView.showSimpleAlert(err.message);
          } else {
            gcn.menuView.showSimpleAlert(ErrorMessage.GENERIC);
          }
          return;
        }

        gcn.loyaltyManager.smsInvitationWasSent();
        Analytics.track(Analytics.EventName.LoyaltySimpleSignupComplete);
        this.trigger(BackboneEvents.GCNSimpleLoyaltySignupView.SmsInvitationWasSent, this);
        if (gcn.screenReaderIsActive) {
          gcn.showNativeToast(`Message sent to: ${this.__userNumber.split('').join(' ')}`);
        }
        gcn.menuView.dismissStablePopup();
      });
    });
    this.__$icon.hide();
    this.__$skipButton.hide();

    return this;
  },
});
